import { FC } from "react";
import styles from "./KanbanCardSkeleton.module.scss";

/**
 * Placeholder card matching Kanban card geometry (shimmer while orders load).
 */
export const KanbanCardSkeleton: FC = () => (
    <div aria-hidden className={styles.card}>
        <div className={`${styles.bone} ${styles.title}`} />
        <div className={`${styles.bone} ${styles.line}`} />
        <div className={`${styles.bone} ${styles.lineWide}`} />
        <div className={styles.footer}>
            <div className={`${styles.bone} ${styles.chip}`} />
            <div className={`${styles.bone} ${styles.price}`} />
        </div>
    </div>
);

export default KanbanCardSkeleton;
